import React from 'react'

interface NoteTagsDisplayProps {
  tags: string[]
  /** Maximum number of tags to show before truncating. Defaults to 3. */
  maxVisible?: number
  className?: string
}

/**
 * Read-only chip list.
 * Shows up to `maxVisible` tags, then "+N more" badge.
 */
const NoteTagsDisplay: React.FC<NoteTagsDisplayProps> = ({
  tags,
  maxVisible = 3,
  className = '',
}) => {
  if (!tags || tags.length === 0) return null

  const visible = tags.slice(0, maxVisible)
  const overflow = tags.length - visible.length

  return (
    <div className={`flex flex-wrap gap-1 items-center ${className}`}>
      {visible.map((tag) => (
        <span
          key={tag}
          className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300 border border-primary-200 dark:border-primary-700 whitespace-nowrap"
        >
          {tag}
        </span>
      ))}
      {overflow > 0 && (
        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 border border-gray-200 dark:border-gray-600 whitespace-nowrap">
          +{overflow}
        </span>
      )}
    </div>
  )
}

export default NoteTagsDisplay

